/**
 * Sayfa Metinleri ekranındaki yuvalar.
 *
 * key      – Site_Text_Key; sitede getPageText(...) çağrısındaki anahtarla AYNI olmalı
 *            (Buhara-Next/src/components/pages/*). Değiştirilmemeli.
 * defaults – Panelde metin girilmezse sitede görünen varsayılan metin
 *            (Buhara-Next/src/locales/*.json'dan alındı). Alan boşken yer tutucu olarak gösterilir.
 */
const SLOTS = [
  {
    "key": "recipes_lead",
    "group": "Tarifler",
    "label": "Başlık altı açıklama",
    "path": "/yemek-tarifleri",
    "defaults": {
      "tr": "Buhara baharatlarıyla hazırlanan tarifler; malzemeleri, adımları ve besin değerleriyle.",
      "en": "Recipes made with Buhara spices, with ingredients, steps and nutritional values.",
      "de": "Rezepte mit Buhara-Gewürzen – mit Zutaten, Zubereitungsschritten und Nährwerten.",
      "fr": "Des recettes préparées avec les épices Buhara, avec ingrédients, étapes et valeurs nutritionnelles.",
      "nl": "Recepten met Buhara-kruiden, met ingrediënten, bereidingsstappen en voedingswaarden."
    }
  },
  {
    "key": "products_lead",
    "group": "Ürünler",
    "label": "Başlık altı açıklama",
    "path": "/urunlerimiz",
    "defaults": {
      "tr": "Doğal ve taze lezzetleri keşfedin.",
      "en": "Discover natural and fresh flavors.",
      "de": "Entdecken Sie natürliche und frische Aromen.",
      "fr": "Découvrez des saveurs naturelles et fraîches.",
      "nl": "Ontdek natuurlijke en verse smaken."
    }
  },
  {
    "key": "blog_lead",
    "group": "Blog",
    "label": "Başlık altı açıklama",
    "path": "/blog",
    "defaults": {
      "tr": "Haberler, Tarif Sırları ve Lezzetli Yazılar",
      "en": "News, Recipe Secrets and Delicious Articles",
      "de": "Nachrichten, Rezeptgeheimnisse und köstliche Artikel",
      "fr": "Actualités, secrets de recettes et articles délicieux",
      "nl": "Nieuws, receptgeheimen en heerlijke artikelen"
    }
  },
  {
    "key": "about_lead",
    "group": "Hakkımızda",
    "label": "Başlık altı açıklama",
    "path": "/hakkimizda",
    "defaults": {
      "tr": "1987’den beri Konya’da baharat üretiyoruz.",
      "en": "Producing spices in Konya since 1987.",
      "de": "Seit 1987 produzieren wir Gewürze in Konya.",
      "fr": "Nous produisons des épices à Konya depuis 1987.",
      "nl": "Sinds 1987 produceren wij kruiden in Konya."
    }
  },
  {
    "key": "production_lead",
    "group": "Üretim",
    "label": "Başlık altı açıklama",
    "path": "/uretim",
    "defaults": {
      "tr": "Üretim tesisimiz ve süreçlerimiz.",
      "en": "Our production facility and processes.",
      "de": "Unsere Produktionsstätte und Prozesse.",
      "fr": "Notre site de production et nos processus.",
      "nl": "Onze productiefaciliteit en processen."
    }
  },
  {
    "key": "certificates_lead",
    "group": "Kalite Belgelerimiz",
    "label": "Başlık altı açıklama",
    "path": "/kalite-belgelerimiz",
    "defaults": {
      "tr": "Üretimimiz Türk Gıda Kodeksi ve Avrupa Birliği standartlarına uygundur. Gıda güvenliği ve kalite belgelerimizi aşağıdan inceleyebilirsiniz; büyütmek için belgeye tıklayın.",
      "en": "Our production complies with the Turkish Food Codex and European Union standards. You can review our food safety and quality certificates below; click a certificate to enlarge it.",
      "de": "Unsere Produktion entspricht dem türkischen Lebensmittelkodex und den Standards der Europäischen Union. Unsere Lebensmittelsicherheits- und Qualitätszertifikate finden Sie unten; klicken Sie zum Vergrößern auf ein Zertifikat.",
      "fr": "Notre production est conforme au Codex alimentaire turc et aux normes de l’Union européenne. Consultez ci-dessous nos certificats de sécurité alimentaire et de qualité ; cliquez sur un certificat pour l’agrandir.",
      "nl": "Onze productie voldoet aan de Turkse Levensmiddelencodex en de normen van de Europese Unie. Bekijk hieronder onze certificaten voor voedselveiligheid en kwaliteit; klik op een certificaat om het te vergroten."
    }
  },
  {
    "key": "dealers_lead",
    "group": "Bayilerimiz",
    "label": "Başlık altı açıklama",
    "path": "/bayilerimiz",
    "defaults": {
      "tr": "Türkiye’deki satış noktalarımız ve dünya genelindeki iş ortaklarımız.",
      "en": "Our sales points in Türkiye and our partners around the world.",
      "de": "Unsere Verkaufsstellen in der Türkei und unsere Partner weltweit.",
      "fr": "Nos points de vente en Turquie et nos partenaires dans le monde.",
      "nl": "Onze verkooppunten in Turkije en onze partners wereldwijd."
    }
  },
  {
    "key": "dealers_tr_title",
    "group": "Bayilerimiz",
    "label": "Türkiye haritası — başlık",
    "path": "/bayilerimiz",
    "defaults": {
      "tr": "Türkiye Bayi Ağımız",
      "en": "Our Dealer Network in Turkey",
      "de": "Unser Händlernetz in der Türkei",
      "fr": "Notre réseau de distributeurs en Turquie",
      "nl": "Ons dealernetwerk in Turkije"
    }
  },
  {
    "key": "dealers_tr_lead",
    "group": "Bayilerimiz",
    "label": "Türkiye haritası — açıklama",
    "path": "/bayilerimiz",
    "defaults": {
      "tr": "Haritadan bir il seçerek o şehirdeki bayimizi görün.",
      "en": "Select a city on the map to see the dealer in that province.",
      "de": "Wählen Sie eine Stadt auf der Karte, um den Händler in dieser Provinz zu sehen.",
      "fr": "Sélectionnez une ville sur la carte pour voir le distributeur de cette province.",
      "nl": "Selecteer een stad op de kaart om de dealer in die provincie te zien."
    }
  },
  {
    "key": "global_partners_title",
    "group": "Bayilerimiz",
    "label": "Global İş Ortaklarımız — başlık",
    "path": "/bayilerimiz",
    "defaults": {
      "tr": "Global İş Ortaklarımız",
      "en": "Our Global Partners",
      "de": "Unsere globalen Partner",
      "fr": "Nos partenaires internationaux",
      "nl": "Onze wereldwijde partners"
    }
  },
  {
    "key": "global_partners_lead",
    "group": "Bayilerimiz",
    "label": "Global İş Ortaklarımız — açıklama",
    "path": "/bayilerimiz",
    "defaults": {
      "tr": "Yurt dışındaki bayilerimiz ve iş ortaklarımızla Buhara lezzetini dünyanın dört bir yanına ulaştırıyoruz.",
      "en": "Together with our dealers and business partners abroad, we bring the taste of Buhara to every corner of the world.",
      "de": "Gemeinsam mit unseren Händlern und Geschäftspartnern im Ausland bringen wir den Geschmack von Buhara in alle Welt.",
      "fr": "Avec nos distributeurs et partenaires à l’étranger, nous faisons voyager la saveur Buhara aux quatre coins du monde.",
      "nl": "Samen met onze dealers en zakenpartners in het buitenland brengen we de smaak van Buhara naar alle hoeken van de wereld."
    }
  },
  {
    "key": "contact_lead",
    "group": "İletişim",
    "label": "Başlık altı açıklama",
    "path": "/iletisim",
    "defaults": {
      "tr": "Buhara Baharat iletişim bilgileri.",
      "en": "Contact details of Buhara Baharat.",
      "de": "Kontaktdaten von Buhara Baharat.",
      "fr": "Coordonnées de Buhara Baharat.",
      "nl": "Contactgegevens van Buhara Baharat."
    }
  },
  {
    "key": "media_lead",
    "group": "Medya",
    "label": "Başlık altı açıklama",
    "path": "/medya",
    "defaults": {
      "tr": "Buhara Baharat medya içerikleri.",
      "en": "Buhara Baharat media content.",
      "de": "Medieninhalte von Buhara Baharat.",
      "fr": "Contenus médias de Buhara Baharat.",
      "nl": "Media-inhoud van Buhara Baharat."
    }
  },
  {
    "key": "catalogs_lead",
    "group": "E-Katalog",
    "label": "Başlık altı açıklama",
    "path": "/kataloglar",
    "defaults": {
      "tr": "Ürün ve tanıtım kataloglarımızı sayfa sayfa çevirerek inceleyebilirsiniz.",
      "en": "Browse our product and brochure catalogues page by page.",
      "de": "Blättern Sie Seite für Seite durch unsere Produkt- und Imagekataloge.",
      "fr": "Feuilletez page par page nos catalogues produits et de présentation.",
      "nl": "Blader pagina voor pagina door onze product- en bedrijfscatalogi."
    }
  }
];

export default SLOTS;
